
export const extractAllPropertyKeysOfContent = (content: string) => {
  const parentStack = [PropertyKey('<instance>', null, false)]
  for (let i = 0; i < content.length; i++) {
    const currentChar = content.charAt(i)
    if (currentChar === '{') {
      return extractPropertyKeysOfObject(content, parentStack, i + 1).propertyKeys
    } else if (currentChar === '[') {
      return extractPropertyKeysOfArray(content, parentStack, i + 1).propertyKeys
    }
  }
  return []
}

const extractPropertyKeysOfObject = (content: string, parentStack: any, startIndex: number) => {
  let currentPropertyKey
  let allPropertyKeys: any = []
  for (let i = startIndex; i < content.length; i++) {
    const currentChar = content.charAt(i)
    if (!isWhitespace(currentChar)) {
      if (currentChar === '{' && currentPropertyKey !== undefined) {
        parentStack.push(currentPropertyKey.propertyKey)
        allPropertyKeys.push(currentPropertyKey.propertyKey)
        const extractedPropertyKeys = extractPropertyKeysOfObject(content, parentStack, i + 1)
        i = extractedPropertyKeys.newIndex
        allPropertyKeys = allPropertyKeys.concat(extractedPropertyKeys.propertyKeys)
        currentPropertyKey = undefined
        parentStack.pop()
      } else if (currentChar === '}') {
        return { propertyKeys: allPropertyKeys, newIndex: i }
      } else if (currentChar === '[') {
        parentStack.push(currentPropertyKey.propertyKey)
        allPropertyKeys.push(currentPropertyKey.propertyKey)
        const extractedPropertyKeys = extractPropertyKeysOfArray(content, parentStack, i + 1)
        i = extractedPropertyKeys.newIndex
        allPropertyKeys = allPropertyKeys.concat(extractedPropertyKeys.propertyKeys)
        currentPropertyKey = undefined
        parentStack.pop()
      } else {
        if (currentPropertyKey === undefined) {
          currentPropertyKey = extractPropertyKey(content, parentStack, i)
          i = currentPropertyKey.newIndex
        } else {
          i = lastIndexOfPropertyValue(content, i)
          allPropertyKeys.push(currentPropertyKey.propertyKey)
          currentPropertyKey = undefined
        }
      }
    }
  }
}

const extractPropertyKeysOfArray = (content: string, parentStack: any[], startIndex: number) => {
  let currentIndex = 0
  let currentKey = PropertyKey(`[${currentIndex}]`, parentStack[parentStack.length - 1], true)
  parentStack.push(currentKey)
  let allPropertyKeys: any[] = []
  for (let i = startIndex; i < content.length; i++) {
    const currentChar = content.charAt(i)
    if (!isWhitespace(currentChar)) {
      if (currentChar === ',') {
        parentStack.pop()
        currentIndex++
        currentKey = PropertyKey(`[${currentIndex}]`, parentStack[parentStack.length - 1], true)
        parentStack.push(currentKey)
      } else if (currentChar === '{') {
        const extractedPropertyKeys = extractPropertyKeysOfObject(content, parentStack, i + 1)
        i = extractedPropertyKeys.newIndex
        allPropertyKeys = allPropertyKeys.concat(extractedPropertyKeys.propertyKeys)
      } else if (currentChar === '[') {
        const extractedPropertyKeys = extractPropertyKeysOfArray(content, parentStack, i + 1)
        i = extractedPropertyKeys.newIndex
        allPropertyKeys = allPropertyKeys.concat(extractedPropertyKeys.propertyKeys)
      } else if (currentChar === ']') {
        parentStack.pop()
        return { propertyKeys: allPropertyKeys, newIndex: i }
      } else {
        i = lastIndexOfPropertyValue(content, i)
        allPropertyKeys.push(parentStack[parentStack.length - 1])
      }
    }
  }
}
  
const extractPropertyKey = (content: string, parentStack: string | any[], startIndex: number) => {
  let quotationMarksFound = 0
  let isEscaped = false
  let startPropertyKeyIndex
  for (let i = startIndex; i < content.length; i++) {
    const currentChar = content.charAt(i)
    if (currentChar === '\\') {
      isEscaped = !isEscaped
    } else {
      if (isQuotationMark(currentChar, isEscaped)) {
        quotationMarksFound++
        if (startPropertyKeyIndex === undefined) {
          startPropertyKeyIndex = i
        }
      } else {
        if (quotationMarksFound === 2) {
          if (currentChar === ':') {
            return { propertyKey: PropertyKey(formatKey(content.substring(startPropertyKeyIndex, i)), parentStack[parentStack.length - 1], false), newIndex: i }
          }
        }
      }
      isEscaped = false
    }
  }
}

const lastIndexOfPropertyValue = (content: string, startIndex: number) => {
  let evenAmountOfQuotationMarks = true
  let isEscaped = false
  for (let i = startIndex; i < content.length; i++) {
    const currentChar = content.charAt(i)
    if (currentChar === '\\') {
      isEscaped = !isEscaped
    } else {
      if (isQuotationMark(currentChar, isEscaped)) {
        evenAmountOfQuotationMarks = !evenAmountOfQuotationMarks
      } else {
        if ((currentChar === ',' || currentChar === '}' || currentChar === ']') && evenAmountOfQuotationMarks) {
          return i - 1
        }
        isEscaped = false
      }
    }
  }
}

const isWhitespace = (currentChar: string) => (currentChar.trim() === '')

const isQuotationMark = (currentChar: string, isEscaped: boolean) => (currentChar === '"' && !isEscaped)

const formatKey = (unformattedKey: string) => {
  const trimmedKey = unformattedKey.trim()
  if (trimmedKey.length > 1 && trimmedKey.startsWith('"') && trimmedKey.endsWith('"')) {
    return trimmedKey.substring(1, trimmedKey.length - 1)
  } else {
    throw new Error(`Key ${unformattedKey} is not wrapped by "".`)
  }
}

const PropertyKey = (key: string, parent: any, isArray: boolean) => {
  const PropertyKey = {
    key,
    parent,
    occurrence: 1,
    isArray,
    propertyPath: () => PropertyKey.parent == null ? [PropertyKey.key] : parent.propertyPath().concat([PropertyKey.key]),
    toString: () => PropertyKey.parent == null ? [PropertyKey.key] : `${PropertyKey.parent.toString()}${PropertyKey.isArray ? PropertyKey.key : `.${PropertyKey.key}`}`
  }
  return PropertyKey
}

export const addPropertyKeyToArray = (propertyKeyArray: any, propertyKey: any) => {
  const propertyKeysInArray = findPropertyKeysInArray(propertyKeyArray, propertyKey)
  if (propertyKeysInArray.length === 0) {
    propertyKeyArray.push(propertyKey)
  } else if (propertyKeysInArray.length === 1) {
    propertyKeysInArray[0].occurrence++
  } else {
    throw new Error(`Property ${propertyKey.toString()} occurs multiple times in propertyKeys.`)
  }
}

const findPropertyKeysInArray = (propertyKeysArray: any, propertyKey: any) =>
  propertyKeysArray.filter((propertyInArray: any) => propertyInArray.parent === propertyKey.parent && propertyInArray.key === propertyKey.key)
